import React from 'react';
import DataResource from '../../../../common/v4/DataResource'
import Panel from '../../../../common/layout/Panel'
import { useParams } from 'react-router-dom';

const WebAccounts = (props) => {
    const { account_id } = useParams();
    const data = {
        url: `/admin/clients/clients/${account_id}/webaccounts`,
        data: {
            data: [],
            metadata: []
        },
        onclick: 'link',
        link: `/clients/clients/${account_id}/webaccounts/{id}`,
        metadata: [
          {
                    label: 'id',
                    source: 'id',
                    type: 'primary',
                    editable: false,
                    visible: false
                },
                {
                    label: 'Email/Login',
                    source: 'email',
                    type: 'email',
                    editable: true,
                    default: '',
                    placeholder: 'name@domain.com'
                },
                {
                    label: 'Name',
                    source: 'name',
                    type: 'text',
                    editable: true,
                    default: '',
                    placeholder: 'First'
                },
                {
                    label: 'Phone',
                    source: 'phone',
                    type: 'text',
                    editable: true,
                    default: '',
                    placeholder: 'Phone'
                },
                {
                    label: 'Timezone',
                    source: 'timezone',
                    type: 'text',
                    editable: true,
                    default: 'America/New_York'
                },
                {
                    label: 'Agent',
                    source: 'is_agent',
                    type: 'boolean',
                    editable: false,
                    default: false
                },
                {
                    label: 'Email Verified',
                    source: 'email_verified',
                    type: 'boolean',
                    editable: false,
                    default: false
                },
                {
                    label: 'Enabled',
                    source: 'enabled',
                    type: 'boolean',
                    editable: true,
                    default: true
                },
                {
                    label : 'Delete',
                    type: 'delete'
                }  
        ]
    }

    return (   
            <Panel title = "Users">
                <DataResource
                    addButtonText = "Create User" 
                    addButtonLink = {`/clients/clients/${account_id}/webaccounts/create`}
                    data = {data}
                    {...props} 
                />
            </Panel>
        )
    }


export default WebAccounts;